import PropTypes from 'prop-types';
import React from 'react';

import styles from './CheckMarkedElement.module.scss';

const CheckMarkedElement = ({ selected, children }) => {
  const containerClassName = [
    styles['checkmark-title'],
    selected ? styles.selected : ''
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClassName} data-test-id="check-marked-element" data-rbf="check-marked-element">
      {children}
    </div>
  );
};

CheckMarkedElement.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.object,
    PropTypes.string,
  ]),
  selected: PropTypes.bool
};

export default React.memo(CheckMarkedElement);
